var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55.891,
  height: 55.891,
  viewBox: "0 0 55.891 55.891"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M52.617 19.244H45.3V4.094A4.1 4.1 0 0 0 41.209 0H4.094A4.1 4.1 0 0 0 0 4.094v32.039a3.189 3.189 0 0 0 5.794 1.836l5.6-7.949h10.111v8.874a3.275 3.275 0 0 0 3.275 3.275h1.05a.819.819 0 1 0 0-1.637h-1.05a1.637 1.637 0 0 1-1.637-1.637V22.519a1.637 1.637 0 0 1 1.637-1.637h27.837a1.637 1.637 0 0 1 1.637 1.637v24.026a.958.958 0 0 1-1.747.552l-1.393-1.977a.819.819 0 1 0-1.336.946l1.393 1.977a2.6 2.6 0 0 0 4.72-1.5V22.519a3.275 3.275 0 0 0-3.275-3.275ZM5.108 28.382a.819.819 0 1 0 0 1.637h4.28l-4.932 7a1.551 1.551 0 0 1-2.819-.889V4.094a2.46 2.46 0 0 1 2.457-2.457h37.115a2.46 2.46 0 0 1 2.456 2.456v15.151h-3.821V6.89a1.914 1.914 0 0 0-1.91-1.91H7.368a1.914 1.914 0 0 0-1.91 1.91v16.239a1.914 1.914 0 0 0 1.91 1.91h14.137v3.343Zm16.4-5.863v.881H7.368a.274.274 0 0 1-.273-.273V6.89a.274.274 0 0 1 .273-.273h30.566a.274.274 0 0 1 .273.273v12.354H24.78a3.275 3.275 0 0 0-3.275 3.275Z",
  "data-name": "Path 774"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M34.658 9.347H19.377a.819.819 0 1 0 0 1.637h15.281a.819.819 0 1 0 0-1.637",
  "data-name": "Path 775"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#011839",
  d: "M10.643 10.984h1.091a.819.819 0 0 0 0-1.637h-1.091a.819.819 0 1 0 0 1.637",
  "data-name": "Path 776"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M15.01 10.984h1.092a.819.819 0 1 0 0-1.637H15.01a.819.819 0 0 0 0 1.637",
  "data-name": "Path 777"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M34.659 13.713H10.643a.819.819 0 1 0 0 1.637h24.016a.819.819 0 1 0 0-1.637",
  "data-name": "Path 778"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#2c2c39",
  d: "M19.376 18.08h-8.733a.819.819 0 1 0 0 1.637h8.733a.819.819 0 1 0 0-1.637",
  "data-name": "Path 779"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "M38.698 34.787a5.731 5.731 0 1 0 5.731 5.731 5.73 5.73 0 0 0-5.731-5.731m2.766 4.746-3.081 3.119a.82.82 0 0 1-1.165 0l-1.287-1.3a.82.82 0 1 1 1.166-1.151l.7.713 2.5-2.529a.82.82 0 0 1 1.166 1.151Z",
  "data-name": "Path 780"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#7654fd",
  d: "m49.947 30.066-10.916-4.849a.82.82 0 0 0-.666 0l-10.916 4.851a.82.82 0 0 0-.486.749v7.46a19.21 19.21 0 0 0 11.4 17.544.82.82 0 0 0 .666 0 19.21 19.21 0 0 0 11.4-17.546v-7.46a.82.82 0 0 0-.482-.749M38.703 47.887a7.371 7.371 0 1 0-.005 0Z",
  "data-name": "Path 781"
})));
export default SvgChat;